import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FilterPlayIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="8" cy="8" r="8" fill={fillColor || '#EFEFF0'} />
      <path
        d="M6 5.86852C6 5.06982 6.89015 4.59343 7.5547 5.03647L10.7519 7.16795C11.3457 7.56377 11.3457 8.43623 10.7519 8.83205L7.5547 10.9635C6.89014 11.4066 6 10.9302 6 10.1315V5.86852Z"
        fill={fillColor || '#FF5B27'}
      />
    </svg>
  );
};

export { FilterPlayIcon };
